import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { observer, useStore } from '@/hooks/storeHooks'
import st from './index.scss'
import { makeAutoObservable } from 'mobx'

// 弹窗组件

// 使用方法：
// import ProblemPopup from '@/components/ProblemPopup'
// import { hoc } from '@/components'
// const Problemp = hoc.ToastBackground(ProblemPopup)
// id = toast.custom(
//     <Problemp
//         title="提问1"
//         titleDes="提问描述1"
//         cancelPop={() => {
//             close()
//         }}
//         submitPop={(data) => {
//             submitPop(data)
//         }}
//         questionsSubjects={questionsSubjects}
//     />
// )
//// 取消弹窗
// function close() {
//     toast.remove(id)
// }
//// 提交回调
// function submitPop(data) {
//     console.log(data)
// }

class reportStore {
    constructor() {
        makeAutoObservable(this)
    }
    textLength = React.createRef()
    fileClick = React.createRef()
    selectRef = React.createRef()
    inputRef = React.createRef()
    checkInputRef = React.createRef()
    imgLists = []
    textareaText = ''
    selectValue = ''
    changeImgLists = (e) => {
        this.imgLists.push(e)
    }
    deleteImgIndex = (index) => {
        this.imgLists.splice(index, 1)
    }
    changetextareaText = (e) => {
        this.textareaText = e
    }
    changeSelectValue = (e) => {
        this.selectValue = e
    }
}

// 上传图片
const UploadImg = observer(function ({ uploaded, imgList, deleteImg }) {
    const { api, user } = useStore()
    const [store] = useState(() => new reportStore())
    function fileChange(e) {
        if (e.target.files.length > 0) {
            var formData = new FormData()
            formData.append('file', e.target.files[0])
            user.post(api.uploadUrl, formData).then((res) => {
                uploaded(res.data.filePath)
            })
        }
    }

    function uploadFun() {
        store.fileClick.current.click()
    }
    return (
        <div
            className={cn({
                [st['img-upload']]: true,
                [st['img-upload-active']]: imgList.length > 0
            })}
        >
            <input
                onChange={(e) => {
                    fileChange(e)
                }}
                ref={store.fileClick}
                className={st['file']}
                type="file"
            ></input>
            {imgList.map((item, index) => {
                return (
                    <div key={index} className={st['preview-img']}>
                        <img key={index} src={item}></img>
                        <div
                            onClick={() => {
                                deleteImg(index)
                            }}
                            className={st['channel-img']}
                        >
                            <img src="https://osscdn.zhongheschool.com/mallP4_2022_08_02/H5/cwDelete.png"></img>
                        </div>
                    </div>
                )
            })}
            {imgList.length == 0 ? (
                <img
                    onClick={() => {
                        uploadFun()
                    }}
                    src="https://osscdn.zhongheschool.com/mallP4_2022_08_02/H5/cw-imgQuestion.png"
                ></img>
            ) : imgList.length == 3 ? null : (
                <img
                    className={st['img-add']}
                    onClick={() => {
                        uploadFun()
                    }}
                    src="https://osscdn.zhongheschool.com/mallP4_2022_08_02/H5/cwadd.png"
                ></img>
            )}
            {imgList.length >= 3 ? null : <span>最多可上传3张图片</span>}
        </div>
    )
})

/**
 *
 * @param {string} title 标题
 * @param {string} titleDes 标题描述
 * @param {string} cancelPop 取消回调
 * @param {string} submitPop 提交回调
 * @param {array} questionsSubjects 问题科目数组
 * @param {boole} uploadImgFun 是否需要上传图片功能
 * @param {string} placeholder 默认提示
 * @param {number} maxLength 最大的输入字数
 * @param {string} echoInputValue 输入框的回显内容
 * @param {boole} thePublic 是否需要公开，在课程的添加笔记里面用到
 * @param {boole} isShow 勾选框状态
 * @param {string} buttonText 文本
 * @param {boole} disabled 是否禁用输入框
 */
export default observer(function ProblemPopup({
    title,
    titleDes,
    cancelPop,
    submitPop,
    questionsSubjects = [],
    uploadImgFun = true,
    placeholder = '请尽量清晰完整的描述提问，以便我们的老师或者其他同学更好的解答您的提问 注意：如果您提交恶意或非法内容，将有一定概率受到同学举报而导致封禁您的言论～',
    maxLength = 300,
    echoInputValue = '',
    thePublic = false,
    buttonText = '提交',
    disabled = false,
    isShow = true
}) {
    const [store] = useState(() => new reportStore())

    // 回显input里面的值
    useEffect(() => {
        store.inputRef.current.value = echoInputValue
        store.changetextareaText(echoInputValue)
        store.textLength.current.innerText = echoInputValue?.length || 0
    }, [echoInputValue])

    useEffect(() => {
        if (thePublic) {
            store.checkInputRef.current.checked = isShow
        }
    }, [])

    // 验证文本框内容
    function checkInput(e) {
        store.textLength.current.innerText = e.target.value.length || 0
        store.changetextareaText(e.target.value)
    }

    // 删除图片
    function deleteImg(index) {
        store.deleteImgIndex(index)
    }

    // 提交图片
    function submitApi() {
        submitPop({
            checkInputValue: thePublic
                ? store.checkInputRef.current.checked
                : null,
            textareaText: store.textareaText,
            selectValue: store.selectValue,
            imgLists: [...store.imgLists]
        })
    }

    // 获取select的内容
    function selectChange(e) {
        store.changeSelectValue(e.target.value)
    }

    return (
        <>
            <div className={st['box']}>
                <div className={st['header']}>
                    <div className={st['header-title']}>{title}</div>
                    <div
                        onClick={() => {
                            cancelPop()
                        }}
                        className={st['close-img']}
                    >
                        ×
                    </div>
                </div>
                <div className={st['text-title']}>{titleDes}</div>
                <div className={st['text-view']}>
                    <textarea
                        disabled={disabled}
                        ref={store.inputRef}
                        onChange={(e) => {
                            checkInput(e)
                        }}
                        id="textarea"
                        maxLength={maxLength}
                        placeholder={placeholder}
                        className={st['textarea']}
                    ></textarea>
                    <div className={st['words']}>
                        <span ref={store.textLength} id="textLength">
                            0
                        </span>
                        /{maxLength}
                    </div>
                </div>
                {uploadImgFun && (
                    <UploadImg
                        uploaded={(file) => {
                            store.changeImgLists(file)
                        }}
                        imgList={store.imgLists}
                        deleteImg={(index) => {
                            deleteImg(index)
                        }}
                    ></UploadImg>
                )}
                {/* 是否公开 */}
                {thePublic && (
                    <div className={st['thePublic']}>
                        <input
                            ref={store.checkInputRef}
                            type="checkbox"
                        ></input>
                        <span>是否公开</span>
                    </div>
                )}

                {questionsSubjects.length > 0 ? (
                    <>
                        <div className={st['questions-title']}>提问科目</div>
                        <div className={st['select-div']}>
                            <select
                                onChange={(e) => {
                                    selectChange(e)
                                }}
                                ref={store.selectRef}
                            >
                                <option value="">请选择</option>
                                {questionsSubjects.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>
                                            {item.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </>
                ) : null}

                <div className={st['popup-button']}>
                    <div
                        onClick={() => {
                            cancelPop()
                        }}
                        className={st['button-parent']}
                    >
                        取消
                    </div>
                    <div
                        onClick={() => {
                            submitApi()
                        }}
                        className={st['button-parent']}
                    >
                        {buttonText}
                    </div>
                </div>
            </div>
        </>
    )
})
